import React from "react";
import logo from "assets/images/sitelogo.svg";
import sendRequest from "hooks/useAxios";
// icons
import {
  BiHomeSmile,
  BiInfoCircle,
  BiPhoneCall,
  BiMessageSquareAdd,
  BiCategoryAlt,
} from "react-icons/bi";
import { BsCreditCard2Front } from "react-icons/bs";
import { VscQuestion } from "react-icons/vsc";
import {
  IoSearchOutline,
  IoExitOutline,
  IoEnterOutline,
} from "react-icons/io5";
import { FiShoppingCart } from "react-icons/fi";
import { NavLink } from "react-router-dom";
import { HiMenu } from "react-icons/hi";
import { GiWallet } from "react-icons/gi";
import {
  RiWallet3Line,
  RiGitRepositoryPrivateLine,
  RiOrderPlayFill,
  RiListSettingsLine,
  RiProfileLine,
} from "react-icons/ri";
import {
  MdOutlineSpaceDashboard,
  MdStorefront,
  MdExitToApp,
} from "react-icons/md";
import { GoChecklist } from "react-icons/go";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { HiOutlineUsers } from "react-icons/hi";
import { SiGooglemessages } from "react-icons/si";
import "./Header.scss";
import Container from "components/LogIn/Container";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";
import CartModal from "common/order/CartModal";
import CartItemsContext from "context/CardItems";
import Dropdown from "react-bootstrap/Dropdown";
import { useState } from "react";
import AddProductModal from "components/admin-panel/addProductModal/AddProductModal";
import { createPortal } from "react-dom";
import MenuMobile from "./MenuMobile";
import useWindowSize from "hooks/useWindowSize";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { find } from "lodash";

const Header = ({ backButtonPressed }) => {
  const auth = useContext(WithAuthentication);
  const nav = useNavigate();
  const links = [
    {
      name: "خانه",
      href: "/",
      id: 1,
      icon: <BiHomeSmile className="me-1" />,
    },
    {
      name: "کیف پول شما",
      href:
        auth.userInfo.userType == "1"
          ? "/customer-panel/financial-department"
          : auth.userInfo.userType == "2" &&
            `shop/financial-department/${auth.userInfo?.bussinesses[0]?.id}`,
      id: 2,
      icon: <RiWallet3Line className="me-1" />,
    },
    {
      name: "درباره ما",
      href: "/d",
      id: 3,
      icon: <BiInfoCircle className="me-1" />,
    },
    {
      name: "تماس با ما",
      href: "/t",
      id: 4,
      icon: <BiPhoneCall className="me-1" />,
    },
    {
      name: "سوالات متداول",
      href: "/s",
      id: 5,
      icon: <VscQuestion className="me-1" />,
    },
    {
      name: "حریم خصوصی",
      href: "/h",
      id: 6,
      icon: <RiGitRepositoryPrivateLine className="me-1" />,
    },
    // {
    //   name: "فروشگاه",
    //   href: "/shop",
    // },
    // {
    //   name: "پشتیبانی",
    //   href: "/support",
    // },
  ];
  const [inventoryWallets, setInvenoryWallets] = useState([]);
  const selectType = (type) => {
    switch (type) {
      case 1:
        return 0;
      case 2:
        return 2;
      default:
        return null;
    }
  };
  const selectUid = (type) => {
    switch (type) {
      case 1:
        return auth.userInfo.id;
      case 2:
        return auth.userInfo.bussinesses[0]?.id;
      default:
        return null;
    }
  };
  const findWallet = () => {
    sendRequest("Find_wallets", {
      conditions: `type/=/${selectType(
        auth.userInfo.userType
      )}@@uid/=/${selectUid(auth.userInfo.userType)}`,
    }).then(({ data }) => {
      console.log("inventory", data[0].current_inventory);
      setInvenoryWallets(data[0].current_inventory);
    });
  };

  const { items, setItems, editCartItems, updateCartItemsFunc, length } =
    useContext(CartItemsContext);
  // console.log("auth*** : ", auth.userInfo);
  const cart = { length: length };
  const [profileLst, setProfileLst] = useState({
    superadmin: [
      {
        name: "داشبورد",
        icon: <MdOutlineSpaceDashboard className="me-1" />,
        link: "admin-panel/dashboard",
        type: "link",
        id: 7,
      },
      {
        name: "سفارشات",
        icon: <RiOrderPlayFill className="me-1" />,
        link: "admin-panel/orders",
        type: "link",
        id: 8,
      },
      {
        name: "لیست خرید گروهی",
        icon: <GoChecklist className="me-1" />,
        link: "admin-panel/GroupShoppingList",
        type: "link",
        id: 14,
      },
      {
        name: "امورمالی",
        icon: <FaRegMoneyBillAlt className="me-1" />,
        link: "admin-panel/financial-department",
        type: "link",
        id: 9,
      },

      {
        name: "افزودن محصول",
        icon: <BiMessageSquareAdd className="me-1" />,
        link: "admin-panel/dashboard",
        type: "modal",
        target: "#addProductModal",
        id: 11,
      },
      {
        name: "لیست محصولات",
        icon: <RiListSettingsLine className="me-1" />,
        link: "admin-panel/products",
        type: "link",
        id: 12,
      },
      {
        name: "مدیریت فروشگاه",
        icon: <MdStorefront className="me-1" />,
        link: "admin-panel/ManagmentStore",
        type: "link",
        id: 13,
      },

      {
        name: "مدیریت گروه کالایی",
        icon: <BiCategoryAlt className="me-1" />,
        link: "admin-panel/HashtagManagement",
        type: "link",
        id: 16,
      },
      {
        name: "مدیریت کاربران",
        icon: <HiOutlineUsers className="me-1" />,
        link: "admin-panel/user-management",
        type: "link",
        id: 10,
      },
      {
        name: "مدیریت کارت بانکی",
        icon: <BsCreditCard2Front className="me-1" />,
        link: "admin-panel/credit-card-management",
        type: "link",
        id: 15,
      },
    ],
    shop: [],
    profile: [
      {
        name: "پروفایل",
        icon: <RiProfileLine className="me-1" />,
        link: "customer-panel/profile",
        type: "link",
        id: 20,
      },
      {
        name: "سفارشات",
        icon: <RiOrderPlayFill className="me-1" />,
        link: "customer-panel/orders",
        type: "link",
        id: 21,
      },
      {
        name: "پیامها",
        icon: <SiGooglemessages className="me-1" />,
        link: "customer-panel/messages",
        type: "link",
        id: 22,
      },
    ],
    sorter: [
      {
        name: "افزودن محصول",
        icon: <BiMessageSquareAdd className="me-1" />,
        link: "admin-panel/dashboard",
        type: "modal",
        target: "#addProductModal",
        id: 31,
      },
      {
        name: "لیست محصولات",
        icon: <RiListSettingsLine className="me-1" />,
        link: "admin-panel/products",
        type: "link",
        id: 32,
      },
    ],
  });
  const [mainShopAdmin, setMainShopAdmin] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedProfileItem, setSelectedProfileItem] = useState(-1);
  const [update, setUpdater] = useState(false);
  const dropDownSection = (title, items) => {
    return (
      <Dropdown
        show={showDropDown}
        onClick={() => {
          setShowDropDown((prev) => !prev);
        }}
      >
        <Dropdown.Toggle className="dropdownToggle">{title}</Dropdown.Toggle>
        <Dropdown.Menu className="drop-down">
          {items.map((v, i) => (
            <Dropdown.Item
              className={`${
                i == selectedProfileItem &&
                (v.id != 11 || v.id != 31) &&
                "drop-down-active"
              } drop-down-item py-1`}
              onClick={() => setSelectedProfileItem(i)}
            >
              {v.type == "link" && (
                <NavLink to={`${v.link}`} className="d-block text-center">
                  <div className="d-flex align-items-center">
                    {v.icon}
                    <span className="w-100 text-start">{v.name}</span>
                  </div>
                </NavLink>
              )}
              {v.type == "modal" && (
                <div
                  className="text-center"
                  data-bs-target={`${v.target}`}
                  data-bs-toggle="modal"
                  backdrop="static"
                >
                  <div className="d-flex align-items-center">
                    {v.icon}
                    {v.name}
                  </div>
                </div>
              )}
            </Dropdown.Item>
          ))}
          <Dropdown.Item>
            <NavLink to={`/`} className=" " style={{}}>
              <div
                className="user-link exit-button"
                onClick={() => {
                  auth.logout();
                  updateCartItemsFunc();
                  nav("/");
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "15px",
                  color: "black",
                }}
              >
                <IoExitOutline className="me-1" />
                خروج
              </div>
            </NavLink>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };
  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();
  useEffect(() => {
    setShowDropDown(false);
    setIsOpen(false);
  }, [backButtonPressed]);
  useEffect(() => {
    width > 1050 && setIsOpen(false);
  }, [width]);
  useEffect(() => {
    let array = [];
    let object = {};
    auth.userInfo?.bussinesses?.map((item) => {
      if (item.type == "0") {
        setMainShopAdmin(true);
      }
      object = {
        name: `ویترین فروشگاه ${item.title}`,
        link: `shop/${item.id}`,
        id: item.id,
        type: "link",
      };
      array.push(object);
    });
    setProfileLst((prev) => {
      return { ...prev, shop: [...array] };
    });
  }, [auth]);
  function changeUserInformation(newInfo) {}
  // console.log("profile", profileLst);
  // console.log(mainShopAdmin, "mainShopAdmin");
  // console.log("****", auth.userInfo?.bussinesses[0]?.logo_file_record[0]?.url);
  return (
    <>
      {console.log("{auth.userInfo.userType", auth.userInfo.userType)}
      {/* {auth.userInfo.userType == 1 && <CartModal></CartModal>} */}

      <Container changeUserInformation={changeUserInformation} />
      <nav className="navbar navbar-expand-xl position-relative header-style">
        <div className="container-fluid">
          <NavLink to="/" className="navbar-brand">
            <img src={logo} alt="logo" />
          </NavLink>
          <div
            className="text-center mx-auto   goroh-market"
            style={{ top: "30px", right: "42%" }}
          >
            <h6 className="fw-bold">گروهـــــــــمارکت</h6>
            <p style={{ fontSize: 13 }}>(اتحادی برای کاهش اتیکت)</p>
          </div>
          <button
            className="navbar-toggler navbar-toggler-right"
            style={{ fontSize: "30px" }}
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarSupportedContent"
            // aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            {/* <span className="navbar-toggler-icon"> */}
            <HiMenu color="tomato" />
            {/* </span> */}
          </button>

          <div
            className="collapse navbar-collapse  justify-content-around align-items-center"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav w-100 align-items-center ms-3">
              {links.map((link, index) => (
                <li
                  key={index}
                  className={`nav-item ${
                    index == 1 ? "d-none" : "d-flex"
                  }   align-items-center`}
                >
                  <NavLink
                    to={link.href}
                    className={`nav-link`}
                    // aria-current="page"
                    // href={link.href}
                  >
                    <div className="d-flex align-items-center">
                      {link.icon}
                      {link.name}
                    </div>
                  </NavLink>
                </li>
              ))}

              {!auth.isLogged ? (
                <span
                  className=" size1 msMobile text-decoration-none text-dark"
                  style={{ cursor: "pointer", marginRight: "auto" }}
                  data-bs-toggle="modal"
                  data-bs-target="#ModalNumber"
                >
                  <IoEnterOutline className="me-1" />
                  ورود
                </span>
              ) : (
                <>
                  <div
                    className="user-link msMobile"
                    style={{ marginRight: "auto", whiteSpace: "nowrap" }}
                  >
                    {/* <NavLink
                      to={`${
                        auth.userInfo.userType == 1
                          ? "/customer-panel/orders"
                          : "/admin-panel/orders"
                      }`}
                      style={{ fontSize: "15px" }}
                    >
                      {auth.userInfo.fullName == " "
                        ? "پروفایل شما"
                        : auth.userInfo.fullName}
                    </NavLink> */}
                    {auth.userInfo.userType == "0" &&
                      dropDownSection("پنل سوپرادمین", profileLst.superadmin)}
                    {auth.userInfo.userType == "1" &&
                      dropDownSection("پنل کاربر", profileLst.profile)}
                    {auth.userInfo.userType == "2" &&
                      dropDownSection("پنل کاربر", profileLst.shop)}
                    {auth.userInfo.userType == "3" &&
                      dropDownSection("پنل مدیر رسته", profileLst.sorter)}
                  </div>

                  {auth.userInfo.userType != "0" && (
                    <NavLink
                      to={
                        auth.userInfo.userType == "1"
                          ? "/customer-panel/financial-department"
                          : auth.userInfo.userType == "2" &&
                            `shop/financial-department/${auth.userInfo?.bussinesses[0]?.id}`
                      }
                    >
                      <div className="nav-link text-dark size1">
                        <RiWallet3Line
                          style={{ fontSize: "18px" }}
                        ></RiWallet3Line>{" "}
                        <span style={{ fontSize: 14 }} className="mx-1 ">
                          کیف پول شما
                        </span>
                        {/* <GiWallet style={{ fontSize: "18px" }}></GiWallet> */}
                      </div>
                    </NavLink>
                  )}
                </>
              )}

              {!mainShopAdmin && auth.isLogged && (
                <li className="nav-item left-side1">
                  <div
                    className="nav-link "
                    data-bs-toggle="modal"
                    data-bs-target="#CartModal"
                  >
                    {/* {cart?.length && <span className="cart">{cart.length}</span>}
                  <FiShoppingCart /> */}
                    <CartModal
                      inventoryWallets={inventoryWallets}
                      setInvenoryWallets={setInvenoryWallets}
                      findWallet={findWallet}
                    ></CartModal>
                  </div>
                </li>
              )}
              {/* <li className="nav-item">
                <div className="nav-link text-dark mt-2 size1">
                  <span className="mx-1 ">کیف پول شما</span>
                  <GiWallet style={{ fontSize: 18 }}></GiWallet>
                </div>
              </li> */}
              {/* <li className="nav-item">
                <button
                  className="nav-link dropdown-toggle dropdown-button"
                  id="navbarDropdown"
                  aria-current="page"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  دسته بندی محصولات
                </button>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <NavLink className="dropdown-item" to="/category-mobile">
                      موبایل
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="category-laptop">
                      لپتاپ
                    </NavLink>
                  </li>

                  <li>
                    <NavLink className="dropdown-item" to="category-car">
                      خودرو
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="category-furniture">
                      مبلمان
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="category-stationery">
                      نوشت افزار
                    </NavLink>
                  </li>
                </ul>
              </li> */}
              {/* <li className="nav-item ">
                <NavLink className="nav-link search-icon" to="/search">
                  <IoSearchOutline />
                </NavLink>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>

      <MenuMobile
        inventoryWallets={inventoryWallets}
        setInvenoryWallets={setInvenoryWallets}
        findWallet={findWallet}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        publicLink={links}
        mainShopAdmin={mainShopAdmin}
        pic={
          auth.userInfo.userType == 1
            ? auth.userInfo.url
            : auth.userInfo.userType == 2 &&
              auth.userInfo?.bussinesses[0]?.logo_file_record[0]?.url
        }
        privateLink={
          auth.userInfo.userType == 0
            ? profileLst.superadmin
            : auth.userInfo.userType == 1
            ? profileLst.profile
            : auth.userInfo.userType == 2
            ? profileLst.shop
            : auth.userInfo.userType == 3
            ? profileLst.sorter
            : [
                {
                  name: "ورود",
                  icon: <IoEnterOutline className="me-1" />,
                  link: "",
                  type: "modal",
                  target: "#ModalNumber",
                  id: -2,
                },
              ]
        }
      />
      {createPortal(
        <AddProductModal></AddProductModal>,
        document.getElementById("modals")
      )}
    </>
  );
};

export default Header;
